import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP, BP_TABLET } from '@rsos/constants/breakpoints';

export const SuggestionsContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 1000;
  box-shadow: ${({ theme }) =>
    `0px 5px 13px 0px ${theme.colors.lightLineDivider}`};
  margin-top: 4px;
  /* WebKit Scrollbar Styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.lightLineDivider};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primaryText};
  }

  /* Firefox Scrollbar */
  scrollbar-color: ${({ theme }) => theme.colors.lightLineDivider}
    ${({ theme }) => theme.colors.background};
  scrollbar-width: thin;
`;

export const ResultWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  position: 'relative',
  width: '100%',
  cursor: 'pointer',
  padding: '8px',
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  letter-spacing: normal;
  user-select: none;
  max-width: ${({ maxWidth }) => maxWidth}px;
  ${({ isHovered, theme }) =>
    isHovered && `background-color: ${theme.colors.highlights}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: 748px;
  }
  @media (max-width: ${BP_TABLET}px) {
    width: 580px;
  }
`;

export const StyledPlaceName = styled(Text).attrs(() => ({
  inline: true,
  size: 'normal',
  color: 'primaryText',
  fontWeight: 'bold',
  px: 1,
}))``;

export const StyledSecondaryAddr = styled(Text).attrs({
  inline: true,
  size: 'small',
  fontWeight: 'regular',
  color: 'secondaryText',
  px: 1,
})``;
